import type {CookieReportSchema} from './schema';

export const COOKIE_REPORT_FRAGMENT = `//groq
	...
`;

export type CookieReportFragment = CookieReportSchema;
